<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal="true"
    :append-to-body="true"
    custom-class="custom-dialog"
  >
    <div slot="title" class="title">
      <div class="title-name">{{ formId ? '编辑情报' : '创建情报' }}</div>
      <div class="side-title"></div>
      <div class="handle-btn"><!-- <i class="el-icon-s-tools" slot="reference" style="cursor:pointer"></i> --></div>
      <div class="dialog-close-btn" @click="dialogVisible = false">X</div>
    </div>
    <bulletinAddInner ref="bulletinAddInner" :handle-save="handleSave" :handle-update="handleUpdate"></bulletinAddInner>
    <span slot="footer">
      <el-button size="mini" type="info" style="margin-right:20px;background-color: #ccced3;border-color: #ccced3;" @click="dialogVisible = false">取消</el-button>
      <template v-if="isSaveShow">
        <el-button v-show="!formId" type="primary" size="mini" @click="saveBulletin">保存</el-button>
        <el-button v-show="formId" type="primary" size="mini" @click="updateBulletin">保存</el-button>
      </template>
    </span>
  </el-dialog>
</template>
<script>
import bulletinAddInner from './bulletinAddInner'

export default {
  components: {
    bulletinAddInner,
  },
  props: {
    handleSave: {
      type: Function,
      default: () => {},
    },
    handleUpdate: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      dialogVisible: false,
      isSaveShow: true,
      formId: '',
    }
  },
  methods: {
    show: async function(params) {
      if (params.formData && params.formData._id) {
        this.formId = params.formData._id
      } else {
        this.formId = ''
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.bulletinAddInner.show(params)
      })
    },
    async saveBulletin(formData) {
      const res = await this.$refs.bulletinAddInner.saveBulletin()
      if (res) {
        this.dialogVisible = false
      }
    },
    updateBulletin() {
      const res = this.$refs.bulletinAddInner.updateBulletin()
      if (res) {
        this.dialogVisible = false
      }
    },
  },
}
</script>
<style scoped src="../../../company/statistics/css/commonCompany.css"></style>
